<template>
  <div class="mb-4">
    <IssuesList></IssuesList>
  </div>
</template>

<script>
import IssuesList from '@/components/Widgets/Issues/IssuesList/IssuesList.vue';
export default {
  name: 'Issues',
  components: {
    IssuesList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>